<div class="d-flex justify-content-end w-100">
    @if (showWeighingButton) {
        <div class="col-auto">
            <p-button
                class="secondary-transparent-btn"
                (onClick)="onClickWeighing()"
                [variant]="'outlined'"
                [label]="weighingLabel">
                <ng-template pTemplate="icon">
                    <i class="fas fa-sliders-h"></i>
                </ng-template>
            </p-button>

            <p-dialog [header]="weighingsLabel" [modal]="true" [(visible)]="visible" [style]="{ width: '30rem' }" (onShow)="loadQuestionGroups()">
                @for (group of questionGroupsAdded; track group) {
                  @if (group?.questionGroup?.id) {
                    <div class="d-flex align-items-center gap-2 mb-4">
                      <label for="groupName" class="font-semibold" style="min-width: 100px;">{{group.questionGroup?.name}}</label>
                      <p-slider [disabled]="true" [(ngModel)]="group.weighing" [ngStyle]="{'flex': '1', 'max-width': '150px'}"></p-slider>
                      <p-inputNumber [disabled]="true" [(ngModel)]="group.weighing" [min]="0" [max]="100" suffix="%" [inputStyle]="{ 'width': '60px' }"></p-inputNumber>
                    </div>
                  }
                }

                <span><b>{{ l('::TotalWeighing') }} {{totalWeighing}} </b></span>
            </p-dialog>
        </div>
    }

    @if (showAddGroupButton) {
        <div class="col-auto">
            <p-button
                [disabled]="unsavedGroup"
                [variant]="'outlined'"
                [icon]="'fas fa-plus'"
                (onClick)="onClickAddGroup()"
                [label]="addGroupLabel">
            </p-button>
        </div>
    }
</div>
